module.exports = __webpack_public_path__ + "img/dropdown-toggle.04bea0dd.svg";